import { NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './shared/shared.module';
import { SbeTokensModule } from '@schoolbelle/api/tokens';
import { LoadingModule } from '@schoolbelle/common/loading';
import { DialogModule } from '@schoolbelle/common/dialog';
import { TranslationModule } from '@schoolbelle/common/translation';
import { PhoneNumberModule } from '@schoolbelle/common/phone-number';
import { StaffAuthService, StaffPurchaseService } from './shared/services';
import { StaffGroupService } from './shared/services/group';
import { AuthService } from '@schoolbelle/api/auth';
import { GroupService } from '@schoolbelle/api/group';
import { LetterModule } from '@schoolbelle/api/letter';
import { LetterTargetModule } from '@schoolbelle/api/letter-target';
import { FileModule, FileService } from '@schoolbelle/api/file';
import { LetterToBoardModule } from '@schoolbelle/api/letter-to-board';
import { BoardModule } from '@schoolbelle/api/board';
import { SmsModule } from '@schoolbelle/api/sms';
import { SurveyG3Module } from '@schoolbelle/api/survey-g3';
import { StaffFileService } from './shared/services/file/file.service';
import { PurchaseService } from '@schoolbelle/api/purchase';

@NgModule({
  imports: [
    SbeTokensModule.forRoot(environment),
    ToastrModule.forRoot({
      positionClass: 'toast-center-center',
    }),
    LoadingModule.forRoot(),
    DialogModule.forRoot(),
    TranslationModule.forRoot(),
    PhoneNumberModule.forRoot(),

    SharedModule.forRoot(),
    LetterModule.forRoot(),
    LetterTargetModule.forRoot(),
    LetterToBoardModule.forRoot(),
    // SmsModule.forRoot(),
    BoardModule.forRoot(),
    FileModule.forRoot(),
    SurveyG3Module.forRoot(),
  ],
  exports: [],
  providers: [
    { provide: AuthService, useExisting: StaffAuthService },
    { provide: GroupService, useExisting: StaffGroupService },
    { provide: PurchaseService, useExisting: StaffPurchaseService },
    { provide: FileService, useExisting: StaffFileService },
  ],
})
export class AppSharedModule {}
